import React from "react";
import "./Crane_Rental.css";
import { Link } from "react-router-dom";
import Roofrepair from "./Category/Lifting_crane_in_Petah_Tikva";
import { Helmet } from "react-helmet";

export default function Crane_Rental() {

  const seo = {
    title:
      "השכרת מנופים | מנוף סל ומנוף זרוע להשכרה | ש.מ הובלות ומנופים",
    description:
      "השכרת מנופים לעבודות הרמה בגובה, מנוף סל, מנוף זרוע, סל הרמה לפי שעה ומנוף סל להרמת אדם. ש.מ הובלות ומנופים מספקת פתרונות הרמה לקבלנים, חברות, עסקים ולקוחות פרטיים.",
    url:
      "https://smtovala.co.il/Crane_Rental",
    image:
      "https://smtovala.co.il/images/6.jpeg"
  };

  const items = [
    {
      title: "השכרת מנוף סל",
      img: "/images/6.png",
      path: "/Basket_crane_rental",
    },
    {
      title: "השכרת מנוף זרוע",
      img: "/images/37.jpeg",
      path: "/Crane_Rental1",
    },
    {
      title: "השכרת סל הרמה לפי שעה",
      img: "/images/1.jpeg",
      path: "/Hourly_Lifting_Basket_Rental",
    },
    {
      title: "השכרת מנוף סל להרמת אדם",
      img: "/images/24.jpeg",
      path: "/Renting_a_basket_crane_for_lifting_a_person",
    },
  ];

  return (
    <div className="Crane_Rental-page">

      {/* =====================================================
          SEO
      ===================================================== */}

      <Helmet>

        <title>{seo.title}</title>

        <meta
          name="description"
          content={seo.description}
        />

        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />

        <link
          rel="canonical"
          href={seo.url}
        />

        {/* Open Graph */}

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:title"
          content={seo.title}
        />

        <meta
          property="og:description"
          content={seo.description}
        />

        <meta
          property="og:url"
          content={seo.url}
        />

        <meta
          property="og:image"
          content={seo.image}
        />

        <meta
          property="og:site_name"
          content="ש.מ הובלות ומנופים"
        />

        <meta
          property="og:locale"
          content="he_IL"
        />

        {/* Twitter */}

        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content={seo.title}
        />

        <meta
          name="twitter:description"
          content={seo.description}
        />

        <meta
          name="twitter:image"
          content={seo.image}
        />

      </Helmet>


      {/* =====================================================
          HERO
      ===================================================== */}

      <div className="Crane_Rental-hero">

        <div className="Crane_Rental-overlay">

          <h1>השכרת מנופים</h1>

        </div>

      </div>


      {/* =====================================================
          SERVICES
      ===================================================== */}

      <div className="page2">

        <div className="grid2">

          {items.map((item, index) => (

            <Link
              to={item.path}
              key={index}
              className="card2"
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: "instant",
                });
              }}
            >

              <img
                src={item.img}
                alt={item.title}
              />

              <div className="card2-btn">
                {item.title}
              </div>

            </Link>

          ))}

        </div>

      </div>

    </div>
  );
}
